import React, { useState, useEffect } from "react";
import { PageList } from "../../components/pageList";

import ActionCellRender from "../../components/actionCellRender";
import { IconPencil, IconTrash, IconSettings } from "@tabler/icons";
import {
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList";
import { useCellRender } from "../../hooks/useCellRender";
import FileList from "../../components/fileList";
import ActivityLog from "../../components/activityLog.js";
import AccountingSourceTab from "../../components/accountingSourceTab";
import RemoteSelect2 from "../../components/remoteSelect2";
import _ from "lodash";
import OrderPendingCase from "../../components/orderPendingCase";
import ReactJson from "react-json-view";
import {
  Select,
  Checkbox,
  TextInput,
  Text,
  Textarea,
  Switch,
  Badge,
  Group,
  NumberInput,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import moment from "moment";
import QuotationDescription from "../../components/quotationDescription";
import QuotationTerms from "../../components/quotationTerm";
import DebitNoteChargeItems from "../../components/debiteNoteChargeItems.js";
import DebitNoteCostItems from "../../components/debiteNoteCostItems.js";
import DebitNoteActionList from "../../components/debitNoteActionList";
import QuotationChargeSummary from "../../components/quotationChargeSummary";
import DummyWidget from "../../components/dummyWidget";
import OrderInsuredList from "../../components/orderInsuredList";
import OrderAddressSelect from "../../components/orderAddressSelect";
import DebitNotePageStats from "../../components/debitNotePageStats";
import OrderConsultantList from "../../components/orderConsultantList";
import OrderApplicantDetail from "../../components/orderApplicantDetail";
import DebitNoteSummary from "../../components/debitNoteSummary";
import DebitNoteTimeline from "../../components/debitNoteTimeline";
import remoteSelect2 from "../../components/remoteSelect2";
import OrderClientSelect from "../../components/orderClientSelect";
import ProductSelection from "../../components/productSelection";
import ConsultantList from "../../components/consultantList";
import FormConfirmation from "../../components/formConfirmation";
import UniqueTextInput from "../../components/uniqueTextInput";
import QuoRequestFileCheckList from "../../components/quoRequestFileCheckList";
import QuoFileList from "../../components/quofileList";
import DebitNotePaymentSummary from "../../components/debitNotePaymentSummary";

import DebitNoteRelatedDocumentSection from "../../components/debitNoteRelatedDocumentSection.js";
import ClientPaymentList from "../../components/clientPaymentList.js";
import RichTextEditor from "../../components/richTextEditor";
import { useAuthUser } from "react-auth-kit";
import DNOrderFileList from "../../components/dnOrderFileList";
import DebitNoteEndorsementList from "../../components/debitNoteEndorsementList";
import CommissionSetting from "../../components/commissionSetting";
import DebitNoteCommissionSetting from "../../components/debitNoteCommissionSetting";
import DebitNotePayrollBidsSection from "../../components/debitNotePayrollBidsSection";
import DebitNoteInsurerSettlementSection from "../../components/debitNoteInsurerSettlementSection";
import DebitNoteRelatedDebitNotesSection from "../../components/debitNoteRelatedDebitNotesSection";
import { useServerApi } from "../../hooks/userServerApi";
import {
  applyTeamUserFilters,
  CONSULTANT_TEAM_SEARCH_ENABLED,
  getTeamUserIds,
  HANDLER_FILTER_USER_PRE_QUERY,
  isConsultantPortalRole,
} from "../../helpers/consultantTeamFilter";
import { useLocation } from "react-router-dom";
import DNParticularList from "../../components/dnParticularList";
//functionLinks
import { functionLinks } from "../../data/navLinks";
import DebitNoteEndorsementSummary from "../../components/debitNoteEndorsementSummary";
import { isMortgageeHirePurchaseProduct } from "../../helpers/orderProductUtils";
import { DATA_DN_AGING_STATUS } from "../../data/options";

const apiEntity = "debitNote";

const debitNoteImportTemplateUrl = `${process.env.REACT_APP_SERVER_URL}/debitNote/downloadTemplate`;

const showCodeInput = process.env.REACT_APP_DEBIT_NOTE_ADD_FORM_SHOW_CODE_INPUT
  ? process.env.REACT_APP_DEBIT_NOTE_ADD_FORM_SHOW_CODE_INPUT === "true"
  : true;

const showPolicyStatus =
  process.env.REACT_APP_DEBIT_NOTE_ADD_FORM_SHOW_POLICY_STATUS === "true";

const getPolicyStatusColor = (status) => {
  if (status === "POLICY_RECEIVED") return "green";
  if (status === "POLICY_DISPATCHED") return "blue";
  return "gray"; //NONE
};

const initialValues = {
  consultants: [],
  type: "NEW",
  date: moment().toISOString(),
  descriptions: [{ title: "", detail: "" }],
  terms: [{ title: "", detail: "" }],
  period: {
    start: null,
    end: null,
  },
  chargeItems: [
    { item: "Premium", currency: "HKD", qty: 1, unitPrice: 0, price: 0 },
    { item: "IA Levy", currency: "HKD", qty: 1, unitPrice: 0, price: 0 },
  ],
  costItems: [
    { item: "Net Premium", currency: "HKD", qty: 1, unitPrice: 0, price: 0 },
    { item: "IA Levy", currency: "HKD", qty: 1, unitPrice: 0, price: 0 },
  ],
  discountAmount: 0,
  taxable: true,
  total: 0,
  logs: [],
  signedBy: { _id: "64198bbc7378cf27c26f4998" },
  status: "HOLD",
  holdCover: {
    date: moment().toISOString(),
    remark: "",
  },
  insuredValue: 0,
  clientFixRate: process.env.REACT_APP_DEBIT_NOTE_CHARGE_DEFAULT_CLIENT_FIX_RATE
    ? +process.env.REACT_APP_DEBIT_NOTE_CHARGE_DEFAULT_CLIENT_FIX_RATE
    : 0,
  providerFixRate: process.env
    .REACT_APP_DEBIT_NOTE_COST_DEFAULT_PROVIDER_FIX_RATE
    ? +process.env.REACT_APP_DEBIT_NOTE_COST_DEFAULT_PROVIDER_FIX_RATE
    : 0,
  mortgageeHirePurchaseName: "",
  mortgageePostalAddress: "",
  mortgagePostDate: null,
};

const mustNeedProduct =
  process.env.REACT_APP_DEBIT_NOTE_NEED_PRODUCT === "true" ||
  !process.env.REACT_APP_DEBIT_NOTE_NEED_PRODUCT;

const resolveRefId = (ref) => (_.isObject(ref) ? ref._id : ref) || null;

const handleDebitNoteProductChange = (value, form) => {
  if (!value) {
    form.setFieldValue("productSnapShot", null);
    form.setFieldValue("provider", null);
    form.setFieldValue("productType", null);
    return;
  }
  form.setFieldValue("productSnapShot", value);
  form.setFieldValue("provider", resolveRefId(value.provider));
  form.setFieldValue("productType", resolveRefId(value.type));
};

export const addFormSchema = {
  name: "debitNoteSchema",
  title: "Create Debit Note",
  description: "Please follow the step to create a New Debit Note",
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
  },
  apiEntity,
  showSaveBar: false,

  initialValues,
  validate: {
    client: (value) => (!value ? "Please select Client" : null),
    product: (value) => {
      if (!mustNeedProduct) return null;
      if (!value) return "Please select Product";
      return null;
    },
    provider: (value) => {
      if (!mustNeedProduct && !value) return "Please select Insurer";
      return null;
    },
    productType: (value) => {
      if (!mustNeedProduct && !value) return "Please select Class";
      return null;
    },
    consultants: (value) => {
      if (_.isEmpty(value)) return "Please select Consultant";

      return null;
    },
    "period.start": (value, values) => {
      if (!value || !values.holdCover?.date) return null;

      const periodStart = moment(value).endOf("day");
      const holdCoverDate = moment(values.holdCover.date);
      // console.log(
      //   "%cdebitNote.js line:146 periodStart",
      //   "color: #007acc;",
      //   value,
      //   periodStart,
      //   holdCoverDate,
      //   periodStart.isBefore(holdCoverDate)
      // );

      if (periodStart.isBefore(holdCoverDate)) {
        return "Period start date must be on or after hold cover date";
      }
      return null;
    },
    "period.end": (value, values) => {
      if (!value || !values.period.start) return null;
      const periodStart = moment(values.period.start);
      const periodEnd = moment(value);
      if (periodEnd.isBefore(periodStart)) {
        return "Period end date must be on or after period start date";
      }
      return null;
    },

    "holdCover.date": (value, values) => {
      if (!value || !values.period.start) return null;
      if (values.type === "ENDOSE") return null;
      const holdCoverDate = moment(value);
      const periodStart = moment(values.period.start);
      if (holdCoverDate.isAfter(periodStart)) {
        return "Hold cover date must be on or before period start date";
      }
      return null;
    },
  },

  layout: {
    containers: [
      {
        key: "t1",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.WIZARD,

        props: {
          variant: "default", //default | pills | outline
          defaultValue: "DN Code",
          orientation: "vertical",
          style: { minHeight: "400px" },
        },
        steps: [
          { key: "t1-0", label: "DN Code", icon: IconSettings },

          { key: "t1-1", label: "Applicant", icon: IconSettings },
          { key: "t1-2", label: "Consultant", icon: IconSettings },
          { key: "t1-2-2", label: "Handler", icon: IconSettings },
          { key: "t1-3", label: "Product", icon: IconSettings },
          { key: "t1-4", label: "Policy", icon: IconSettings },

          { key: "t1-5", label: "Confirmation", icon: IconSettings },
        ],
      },
    ],
    fields: [
      {
        name: "type",
        component: Select,
        parent: "t1-0",
        props: {
          label: "Type",
          data: [
            { label: "New Biz", value: "NEW" },
            { label: "Renewal", value: "RENEW" },
            { label: "Endorsement", value: "ENDOSE" },
          ],
        },
      },
      {
        name: "code",
        component: UniqueTextInput,
        parent: "t1-0",
        visibleOnly: showCodeInput,
        props: {
          required: true,
          uniqueEntity: "debitNote",
          errorMessage: "Debit Note is already exist.",
          label: "Code (Auto if empty)",
          placeholder: "DN23100011",
          mt: 0,
        },
      },
      {
        name: "renewalCount",
        component: NumberInput,
        parent: "t1-0",
        visibleOnly: (data) => data.type === "RENEW",
        props: {
          label: "Renewal Count",
          placeholder: "1",
        },
      },

      {
        name: "client",
        component: remoteSelect2,
        parent: "t1-1",
        props: {
          apiEntity: "client",
          required: true,
          label: "Applicant",
          placeholder: "Search Client By Name / HKID/ BR ",
          valueField: "_id",
          labelField: "name",
          allowClear: true,
          labelRender: (data) =>
            `[ ${data.code ?? data.code ?? " -- "} ] ${data.name} ${
              data.cname ? `(${data.cname})` : ""
            } `,
          //   labelRender: (data) => `${data.cname}`,
          multiple: false,
          // preQuery: { $and: [ {isConsultant : true}, {isActive: true} ] },
          // preQuery:  {isConsultant : true} ,
          searchFields: ["name", "id", "cname", "code"],
          clearable: true,
          onDataChange: (value, form) => {
            //Set Consultant
            if (!value || _.isEmpty(value.consultants))
              form.setFieldValue("consultants", []);
            else {
              form.setFieldValue(
                "consultants",
                value.consultants.map((c) => c._id),
              );
            }
          },
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },
      {
        name: "client2",
        component: OrderClientSelect,
        parent: "t1-1",
        props: {},
      },

      {
        name: "consultants",
        component: remoteSelect2,
        parent: "t1-2",
        props: {
          apiEntity: "user",
          required: true,
          label: "Consultants",
          placeholder: "Please select consultant(s)",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `${data.name} ${data.aliasName ? `, ${data.aliasName}` : ""} (${
              data.staffId ?? " -- "
            })`,
          multiple: true,
          preQuery: {
            $and: [{ isConsultant: true }, { status: "ACTIVE" }],
          },
          searchFields: [
            "aliasName",
            "name",
            "staffId",
            "cname",
            "email",
            "phone",
          ],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },
      {
        name: "consultantList",
        component: ConsultantList,
        parent: "t1-2",
        props: {
          field: "consultants",
        },
      },
      {
        name: "signedBy",
        component: remoteSelect2,
        parent: "t1-2-2",
        props: {
          apiEntity: "user",
          // required: true,
          label: "Handler 1",
          placeholder: "Please select handler 1",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `${data.name} ${data.aliasName ? `, ${data.aliasName}` : ""} (${
              data.staffId ?? " -- "
            })`,
          multiple: false,
          preQuery: {
            $and: [{ isConsultant: true }, { status: "ACTIVE" }],
          },
          searchFields: [
            "aliasName",
            "name",
            "staffId",
            "cname",
            "email",
            "phone",
          ],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },
      {
        name: "signedBy2",
        component: remoteSelect2,
        parent: "t1-2-2",
        props: {
          apiEntity: "user",
          // required: true,
          label: "Handler 2",
          placeholder: "Please select handler 1",
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `${data.name} ${data.aliasName ? `, ${data.aliasName}` : ""} (${
              data.staffId ?? " -- "
            })`,
          multiple: false,
          preQuery: {
            $and: [{ isConsultant: true }, { status: "ACTIVE" }],
          },
          searchFields: [
            "aliasName",
            "name",
            "staffId",
            "cname",
            "email",
            "phone",
          ],
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },

      {
        name: "product",
        component: RemoteSelect2,
        parent: "t1-3",
        visibleOnly: (values, accessRight) => mustNeedProduct,
        props: {
          label: "Product",
          apiEntity: "product",
          required: false,
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `[ ${data.code} ] ${data.name}${data.cname ? ` ${data.cname}` : ""}`,
          multiple: false,
          clearable: true,
          searchFields: ["name", "code", "cname"],
          sort: {
            by: "code",
            order: "asc",
          },
          onDataChange: handleDebitNoteProductChange,
        },
      },
      {
        name: "provider",
        component: RemoteSelect2,
        parent: "t1-3",
        props: {
          label: "Insurer",
          required: false,
          apiEntity: "provider",
          size: "md",
          valueField: "_id",
          labelField: "name",
          searchFields: ["name", "code", "cname"],

          labelRender: (data) =>
            _.truncate(`[ ${data.code} ] ${data.name} ${data.cname ?? ""}`, {
              length: 65,
            }),
          multiple: false,
          pageSize: 10000,
          searchable: true,
          clearable: true,
          sort: {
            by: "code",
            order: "asc",
          },
        },
      },
      {
        name: "productType",
        component: RemoteSelect2,
        parent: "t1-3",

        props: {
          label: "Class",
          required: false,
          // size: "xs",
          apiEntity: "productType",
          valueField: "_id",
          labelField: "name",
          searchFields: ["name", "code", "cname"],

          labelRender: (data) =>
            `[ ${data.code} ] ${data.name} ${data.cname ?? ""}`,
          multiple: false,
          searchable: true,
          clearable: true,
          preQuery: {
            category: {
              $in: ["62f2126bfecf22b7db4ef51c"],
            },
          },
          pageSize: 10000,
          sort: {
            by: "code",
            order: "asc",
          },
          onDataChange: (value, form) => {
            const snap = form.values.productSnapShot || {};
            form.setFieldValue("productSnapShot", { ...snap, type: value });
          },
        },
      },

      {
        name: "policyNumber",
        component: TextInput,
        parent: "t1-4",
        props: {
          label: "Policy Number",
          showProductSnapShot: false,
        },
      },
      {
        name: "policyStatus",
        component: Select,
        parent: "t1-4",
        props: {
          label: "Policy Status",
          data: [
            {
              label: "None",
              value: "NONE",
            },
            {
              label: "Policy Received",
              value: "POLICY_RECEIVED",
            },
            {
              label: "Policy Dispatched",
              value: "POLICY_DISPATCHED",
            },
          ],
        },
      },

      {
        name: "holdCover.date",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Hold Cover Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "period.start",
        component: DatePicker,
        parent: "t1-4",
        type: "datePicker",

        props: {
          label: "Period From",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "period.end",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Period To",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "date",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Debit Note Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },
      //Policy received date
      {
        name: "policyReceivedAt",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Policy Received Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },
      //Policy dispatched date
      {
        name: "policyDispatchedAt",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Policy Dispatched Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "confirm",
        component: FormConfirmation,
        parent: "t1-5",
        props: {
          successText: [
            "Please confirm only if the provided information is correct.",
          ],
        },
      },
    ],
  },
};

export const adjustFormSchema = {
  name: "debitNoteSchema",
  title: "Adjust Debit Note",
  description: "Please follow the step to  adjust the Debit Note",
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
  },
  apiEntity,
  showSaveBar: false,

  initialValues,

  layout: {
    containers: [
      {
        key: "t1",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.WIZARD,

        props: {
          variant: "default", //default | pills | outline
          defaultValue: "DN Code",
          orientation: "vertical",
          style: { minHeight: "400px" },
        },
        steps: [
          { key: "t1-0", label: "DN Code", icon: IconSettings },
          { key: "t1-1", label: "Client", icon: IconSettings },
          { key: "t1-3", label: "Product", icon: IconSettings },
          { key: "t1-4", label: "Policy", icon: IconSettings },

          { key: "t1-5", label: "Confirmation ", icon: IconSettings },
        ],
      },
    ],
    fields: [
      {
        name: "type",
        component: Select,
        parent: "t1-0",
        props: {
          label: "Type",
          data: [
            { label: "New Biz", value: "NEW" },
            { label: "Renewal", value: "RENEW" },
            { label: "Endorsement", value: "ENDOSE" },
          ],
        },
      },
      {
        name: "code",
        component: UniqueTextInput,
        parent: "t1-0",
        props: {
          required: true,
          uniqueEntity: "debitNote",
          errorMessage: "Debit Note is already exist.",
          label: "Code (Auto if empty)",
          placeholder: "DN23100011",
          mt: 0,
        },
      },
      {
        name: "renewalCount",
        component: NumberInput,
        parent: "t1-0",
        visibleOnly: (data) => data.type === "RENEW",
        props: {
          label: "Renewal Count",
          placeholder: "0",
        },
      },
      {
        name: "client",
        component: remoteSelect2,
        parent: "t1-1",
        props: {
          apiEntity: "client",
          required: true,
          label: "Applicant",
          placeholder: "Search Client By Name / HKID/ BR ",
          valueField: "_id",
          labelField: "name",
          allowClear: true,
          labelRender: (data) =>
            `[ ${data.code ?? data.code ?? " -- "} ] ${data.name} ${
              data.cname ? `(${data.cname})` : ""
            } `,
          //   labelRender: (data) => `${data.cname}`,
          multiple: false,
          // preQuery: { $and: [ {isConsultant : true}, {isActive: true} ] },
          // preQuery:  {isConsultant : true} ,
          searchFields: ["name", "id", "cname", "code"],
          clearable: true,
          onDataChange: (value, form) => {
            //Set Consultant
            if (!value || _.isEmpty(value.consultants))
              form.setFieldValue("consultants", []);
            else {
              form.setFieldValue(
                "consultants",
                value.consultants.map((c) => c._id),
              );
            }
          },
          sort: {
            by: "name",
            order: "asc",
          },
        },
      },
      {
        name: "client2",
        component: OrderClientSelect,
        parent: "t1-1",
        props: {},
      },
      {
        name: "product",
        component: RemoteSelect2,
        parent: "t1-3",
        visibleOnly: (values, accessRight) => mustNeedProduct,
        props: {
          label: "Product",
          apiEntity: "product",
          required: false,
          valueField: "_id",
          labelField: "name",
          labelRender: (data) =>
            `[ ${data.code} ] ${data.name}${data.cname ? ` ${data.cname}` : ""}`,
          multiple: false,
          clearable: true,
          searchFields: ["name", "code", "cname"],
          sort: {
            by: "code",
            order: "asc",
          },
          onDataChange: handleDebitNoteProductChange,
        },
      },
      {
        name: "provider",
        component: RemoteSelect2,
        parent: "t1-3",
        props: {
          label: "Insurer",
          required: false,
          apiEntity: "provider",
          size: "md",
          valueField: "_id",
          labelField: "name",
          searchFields: ["name", "code", "cname"],

          labelRender: (data) =>
            _.truncate(`[ ${data.code} ] ${data.name} ${data.cname ?? ""}`, {
              length: 65,
            }),
          multiple: false,
          pageSize: 10000,
          searchable: true,
          clearable: true,
          sort: {
            by: "code",
            order: "asc",
          },
        },
      },
      {
        name: "productType",
        component: RemoteSelect2,
        parent: "t1-3",

        props: {
          label: "Class",
          required: false,
          // size: "xs",
          apiEntity: "productType",
          valueField: "_id",
          labelField: "name",
          searchFields: ["name", "code", "cname"],

          labelRender: (data) =>
            `[ ${data.code} ] ${data.name} ${data.cname ?? ""}`,
          multiple: false,
          searchable: true,
          clearable: true,
          preQuery: {
            category: {
              $in: ["62f2126bfecf22b7db4ef51c"],
            },
          },
          pageSize: 10000,
          sort: {
            by: "code",
            order: "asc",
          },
          onDataChange: (value, form) => {
            const snap = form.values.productSnapShot || {};
            form.setFieldValue("productSnapShot", { ...snap, type: value });
          },
        },
      },

      {
        name: "policyNumber",
        component: TextInput,
        parent: "t1-4",
        props: {
          label: "Policy Number",
          showProductSnapShot: false,
        },
      },
      {
        name: "policyStatus",
        component: Select,
        parent: "t1-4",
        props: {
          label: "Policy Status",
          data: [
            {
              label: "None",
              value: "NONE",
            },
            {
              label: "Policy Received",
              value: "POLICY_RECEIVED",
            },
            {
              label: "Policy Dispatched",
              value: "POLICY_DISPATCHED",
            },
          ],
        },
      },

      {
        name: "holdCover.date",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Hold Cover Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "period.start",
        component: DatePicker,
        parent: "t1-4",
        type: "datePicker",

        props: {
          label: "Period From",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "period.end",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Period To",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },

      {
        name: "date",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Debit Note Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },
      //Policy received date
      {
        name: "policyReceivedAt",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Policy Received Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },
      //Policy dispatched date
      {
        name: "policyDispatchedAt",
        component: DatePicker,
        type: "datePicker",
        parent: "t1-4",
        props: {
          label: "Policy Dispatched Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
        },
      },
      {
        name: "confirm",
        component: FormConfirmation,
        parent: "t1-5",
        props: {
          successText: [
            "Please confirm only if the provided information is correct.",
          ],
        },
      },
    ],
  },
};

const DebitNote = ({ role = "MANAGEMENT" }) => {
  const [cellRender] = useCellRender();
  const [preQuery, setPreQuery] = useState(() =>
    role !== "CONSULTANT" ? {} : undefined,
  );
  const [teamUserIds, setTeamUserIds] = useState(null);
  const auth = useAuthUser();
  const [api] = useServerApi();
  const userRole = auth()?.userRole?.name?.toUpperCase();

  let showCommissionSetting = true;

  if (process.env.REACT_APP_DEBIT_NOTE_COMMISSION_TAB_HIDDEN_TO) {
    const hiddenTo =
      process.env.REACT_APP_DEBIT_NOTE_COMMISSION_TAB_HIDDEN_TO.split(",").map(
        (s) => s.trim(),
      );
    if (hiddenTo.includes(userRole)) {
      showCommissionSetting = false;
    }
  }

  //get the current link
  const currentLink = useLocation().pathname;

  const currentLinkId = functionLinks.find(
    (l) => l.link === currentLink,
  )?.linkId;
  const accessRight = auth()?.userRole?.links.find(
    (l) => l.link === currentLinkId,
  )?.accessRight;

  const showCostItems = accessRight == 15;

  const tableSchema = {
    showActionColumn: true,
    preQuery,
    copyToNewFields: [
      "type",
      "client",
      "commissionRate",
      "product",
      "productType",
      "provider",
      "clientType",
      "discountAmount",
      "clientPayable",
      "period",
      "consultants",
      "signedBy",
      "checkList",
      "to",
      "address",
      "addressStr",
      "descriptions",
      "terms",
      "chargeItems",
      "costItems",
      "refundItems",
      "total",
      "costTotal",
      "profit",
      "currency",
      "insured",
      "refNo",
    ],
    columns: (() => {
      const cols = [
      {
        field: "code",
        headerName: "DN",
        sortable: true,
        cellRender: (col, data) =>
          cellRender.DebitNoteCode(data, true, true, currentLink, true),
        filterable: true,
        width: 150,

        filter: {
          apiEntity: "debitNote",
          field: "type",
          label: "DN Types",
          width: 250,
          height: 300,
        },
      },
      // {
      //   field: "type",
      //   headerName: "Type",
      //   sortable: true,
      //   filterable: true,
      //   width: 80,
      //   cellRender: (col, data) => cellRender.DebitNoteType(data.type),
      //   filter: {
      //     apiEntity: "debitNote",
      //     field: "type",
      //     label: "DN Type",
      //     width: 350,
      //     height: 300,
      //   },
      // },
      {
        field: "paymentStatus",
        headerName: "Payment",
        sortable: true,
        filterable: true,
        filter: {
          apiEntity: "debitNote",
          field: "paymentStatus",
          label: "Payment Status",
          width: 250,
          height: 300,
        },
        cellRender: (col, data) => (
          <>
            {cellRender.DebitNotePaymentStatus(data.paymentStatus)}
            <div>{cellRender.Currency(data?.clientPayable ?? 0)}</div>

            <Text
              color={
                !data?.payment?.amount
                  ? "red"
                  : data?.payment?.amount < data.clientPayable
                    ? "red"
                    : "green"
              }
            >
              {cellRender.Currency(data?.payment?.amount ?? 0)}
            </Text>
            {data.discountAmount > 0 && (
              <span>
                <Badge size="xs" radius={0} color="red" mt="xs" mb={1}>
                  Discount
                </Badge>
                {cellRender.Currency(-data.discountAmount)}
              </span>
            )}
          </>
        ),
      },

      {
        field: "agingStatus",
        headerName: "Aging",
        sortable: true,
        filterable: true,
        width: 110,
        filter: {
          apiEntity: "debitNote",
          field: "agingStatus",
          label: "Aging Status",
          width: 250,
          height: 300,
        },
        cellRender: (col, data) =>
          cellRender.DebitNoteAgingStatus(data.agingStatus),
      },

      {
        field: "commissionRate",
        headerName: "Cost",
        sortable: true,

        cellRender: (col, data) => (
          <>
            {showCostItems && (
              <>
                <Text color={data.commissionRate > 0 ? "green" : "red"}>
                  {data.commissionRate}%
                </Text>
                <Text color="dimmed">
                  {cellRender.Currency(data.costTotal)}
                </Text>
              </>
            )}
            {!showCostItems && <Text color="dimmed">--</Text>}
          </>
        ),
      },

      {
        field: "provider",
        headerName: "Insurer",
        filterOnly: true,
        filterable: true,
        filter: {
          apiEntity: "debitNote",
          field: "provider",
          label: "Insurer",
          width: 320,
          height: 300,
          populate: {
            model: "Provider",
            select: "name cname code shortName",
            labelField: "name",
            sort: { name: 1 },
          },
        },
      },

      {
        field: "product",
        headerName: "Product",
        sortable: true,
        cellRender: (col, data) => {
          if (data.product) return cellRender.ProductInfo(data.product);
          if (data.productType || data.provider)
            return (
              <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
                <Text color="dimmed" size="xs">
                  {cellRender.ProductInfo2(data)}
                </Text>
              </div>
            );
        },
        width: 300,
        filterable: true,
        filter: {
          apiEntity: "debitNote",
          field: "productType",
          label: "Product Type",
          width: 350,
          height: 300,
          populate: {
            model: "ProductType",
            select: "name cname code shortName",
            labelField: "name",
            sort: { code: 1 },
          },
        },
      },
      // {
      //   field: "policyNumber",
      //   headerName: "Policy Number",
      //   sortable: true,
      // },
      {
        field: "policyNumber",
        headerName: "Policy",
        sortable: true,
        filterable: true,
        filter: {
          apiEntity: "debitNote",
          field: "policyStatus",
          label: "Policy Status",
          width: 350,
          height: 300,
          // populate: {
          //   model: "ProductType",
          //   select: "name cname code shortName",
          //   labelField: "name",
          //   sort: { code: 1 },
          // },
        },

        cellRender: (col, data) => (
          <div>
            {showPolicyStatus && (
              <Badge
                size="xs"
                radius={0}
                color={
                  data.policyStatus ===
                  getPolicyStatusColor(data.policyStatus ?? "NONE")
                }
                mb={1}
              >
                {data.policyStatus ?? "NONE"}
              </Badge>
            )}

            <Text>{data.policyNumber ?? ""}</Text>
            {data.period?.start && (
              <Text size="xs" color="dimmed">
                {moment(data.period.start).format("YYYY/MM/DD")}
              </Text>
            )}
            {data.period?.end && (
              <Text size="xs" color="dimmed">
                - {moment(data.period.end).format("YYYY/MM/DD")}
              </Text>
            )}
          </div>
        ),
      },

      {
        field: "client",
        headerName: "Applicant",
        sortable: true,
        width: 350,
        cellRender: (col, data) => cellRender.ClientInfo(data.client),
        filterable: true,

        filter: {
          apiEntity: "debitNote",
          field: "clientType",
          label: "Client Type",
          width: 250,
          height: 300,
        },
      },

      {
        field: "consultants",
        headerName: "Consultants",
        sortable: true,
        filterable: true,
        width: 240,
        filter: {
          apiEntity: "debitNote",
          field: "consultants",
          label: "Consultants",
          width: 300,
          height: 320,
          populate: {
            model: "User",
            select: "name cname staffId aliasName",
            labelField: "name",
            sort: { name: 1 },
          },
        },
        cellRender: (col, data) =>
          cellRender.Users(data.consultants, 4, true, false, false),
      },

      {
        field: "signedBy",
        headerName: "Handler",
        filterOnly: true,
        filterable: true,
        filter: {
          apiEntity: "debitNote",
          field: "signedBy",
          label: "Handler",
          includeEmpty: true,
          width: 300,
          height: 320,
          userPreQuery: HANDLER_FILTER_USER_PRE_QUERY,
          populate: {
            model: "User",
            select: "name cname staffId aliasName",
            labelField: "name",
            sort: { name: 1 },
          },
        },
      },

      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {
              //   color:"red"
            },
          },
        ],
        actionMenu:
          accessRight == 15
            ? [
                {
                  name: "copy",
                  label: "Copy",
                  icon: IconTrash,
                  props: {
                    // color: "red",
                  },
                },
                {
                  name: "delete",
                  label: "Delete data",
                  icon: IconTrash,
                  props: {
                    color: "red",
                  },
                },
              ]
            : null,
      },
    ];
      if (isConsultantPortalRole(role) && teamUserIds) {
        applyTeamUserFilters(cols, teamUserIds, ["consultants", "signedBy"]);
      }
      return cols;
    })(),
    searchableFields: [
      "status",
      "clientType._id",
      "productType._id",
      "client.name",
      "searchText",
      "policyNumber",
      "code",
    ],
    advanceFilters: [
      {
        field: "type",
        label: "DN Type",
        type: "select",
        options: [
          {
            label: "New Biz",
            value: "NEW",
          },
          {
            label: "Renewal",
            value: "RENEW",
          },
          {
            label: "Endorsement",
            value: "ENDORSEMENT",
          },
          {
            label: "Credit Note",
            value: "CREDIT",
          },
        ],
      },
      {
        field: "status",
        label: "DN Status",
        type: "select",
        options: [
          {
            label: "Draft",
            value: "DFT",
          },
          {
            label: "Cancel",
            value: "CAN",
          },
          {
            label: "Hold",
            value: "HOLD",
          },
          {
            label: "Confirm",
            value: "CONFIRMED",
          },

          {
            label: "Expired",
            value: "EXP",
          },
        ],
      },
      {
        field: "paymentStatus",
        type: "select",
        label: "Payment Status",
        options: [
          {
            label: "Waiting",
            value: "WAIT",
          },
          {
            label: "Matching",
            value: "MATCHING",
          },
          {
            label: "Direct",
            value: "DIRECT",
          },
          {
            label: "Partial",
            value: "PARTIAL",
          },
          {
            label: "Paid",
            value: "PAID",
          },
          {
            label: "Cancelled",
            value: "CANCELLED",
          },
          {
            label: "Settled",
            value: "SETTLED",
          },
        ],
      },
      {
        field: "agingStatus",
        type: "select",
        label: "Aging Status",
        options: DATA_DN_AGING_STATUS,
      },
      {
        field: "policyStatus",
        type: "select",
        label: "Policy Status",
        options: [
          {
            label: "None",
            value: "NONE",
          },
          {
            label: "Policy Received",
            value: "POLICY_RECEIVED",
          },
          {
            label: "Policy Dispatched",
            value: "POLICY_DISPATCHED",
          },
        ],
      },
      {
        field: "period.start",
        type: "dateRange",
        label: "Policy Start",
      },
      {
        field: "period.end",
        type: "dateRange",
        label: "Policy End",
      },
      {
        field: "policyDispatchedAt",
        type: "dateRange",
        label: "Policy Dispatched Date",
      },

      {
        field: "provider",
        type: "RemoteSelect",
        label: "Provider",
        props: {
          apiEntity: "provider",
          valueField: "_id",
          select: "name code shortName cname",
          searchFields: ["name", "code", "shortName", "cname"],
          labelField: "name",
          labelRender: (data) =>
            _.truncate(`[ ${data.code} ] ${data.name} ${data.cname ?? ""}`, {
              length: 65,
            }),
          sort: {
            by: "code",
            order: "asc",
          },
          pageSize: 10000,
        },
      },
      //class
      {
        field: "productType",
        type: "RemoteSelect",
        label: "Class",
        props: {
          apiEntity: "productType",
          valueField: "_id",
          select: "name code shortName cname",
          labelField: "name",
          searchFields: ["name", "code", "shortName", "cname"],
          clearable: true,
          allowClear: true,
          sort: {
            by: "code",
            order: "asc",
          },
          pageSize: 10000,
          labelRender: (data) =>
            `[ ${data.code} ] ${data.name} ${data.cname ?? ""}`,
        },
      },
      {
        field: "client",
        type: "RemoteSelect",
        label: "Client",
        props: {
          apiEntity: "client",
          valueField: "_id",
          select: "name code shortName cname",
          // labelField: "name",
          labelRender: (data) =>
            `[ ${data.code ?? data.code ?? " -- "} ] ${data.name} ${
              data.cname ? `(${data.cname})` : ""
            } `,
          searchFields: ["name", "id", "cname", "code"],
          clearable: true,
          allowClear: true,
          sort: {
            by: "code",
            order: "asc",
          },
          pageSize: 10000,
        },
      },
      {
        field: "consultants",
        type: "RemoteSelect",
        label: "Consultants",
        props: {
          apiEntity: "user",
          valueField: "_id",
          select: "name code shortName cname staffId aliasName",
          labelField: "name",
          labelRender: (data) => {
            // if (!data) return null;
            try {
              let text = "";
              if (data?.staffId) text += `[${data?.staffId}] `;
              if (data?.name) text += `${data?.name}`;
              if (data?.aliasName) text += ` (${data?.aliasName})`;
              return text;
            } catch (e) {
              console.error(e);
              return "";
            }
          },
          searchFields: [
            "name",
            "code",
            "shortName",
            "cname",
            "staffId",
            "aliasName",
          ],
          clearable: true,
          allowClear: true,
          sort: {
            by: "code",
            order: "asc",
          },
          pageSize: 10000,
        },
      },
      {
        field: "policyNumber",
        type: "text",
        label: "Policy Number",
      },

      //signedBy, signedBy2
      {
        field: "signedBy",
        type: "RemoteSelect",
        label: "Handler 1",
        props: {
          apiEntity: "user",
          valueField: "_id",
          select: "name code shortName cname staffId aliasName",
          labelField: "name",
          labelRender: (data) => {
            try {
              let text = "";
              if (data?.staffId) text += `[${data?.staffId}] `;
              if (data?.name) text += `${data?.name}`;
              if (data?.aliasName) text += ` (${data?.aliasName})`;
              return text;
            } catch (e) {
              console.error(e);
              return "";
            }
          },
          searchFields: [
            "name",
            "code",
            "shortName",
            "cname",
            "staffId",
            "aliasName",
          ],
          preQuery: {
            $and: [{ isConsultant: true }, { status: "ACTIVE" }],
          },
          sort: {
            by: "name",
            order: "asc",
          },
          pageSize: 10000,
          clearable: true,
          allowClear: true,
        },
      },
      {
        field: "signedBy2",
        type: "RemoteSelect",
        label: "Handler 2",
        props: {
          apiEntity: "user",
          valueField: "_id",
          select: "name code shortName cname staffId aliasName",
          labelField: "name",
          labelRender: (data) => {
            try {
              let text = "";
              if (data?.staffId) text += `[${data?.staffId}] `;
              if (data?.name) text += `${data?.name}`;
              if (data?.aliasName) text += ` (${data?.aliasName})`;
              return text;
            } catch (e) {
              console.error(e);
              return "";
            }
          },
          searchFields: [
            "name",
            "code",
            "shortName",
            "cname",
            "staffId",
            "aliasName",
          ],
          preQuery: {
            $and: [{ isConsultant: true }, { status: "ACTIVE" }],
          },
          sort: {
            by: "name",
            order: "asc",
          },
          pageSize: 10000,
          clearable: true,
          allowClear: true,
        },
      },
    ],

    select: [
      "date code particulars clientType provider policyStatus productType type period product policyNumber client consultants status payment paymentStatus agingStatus clientPayable createdAt signedAt discountAmount commissionRate costTotal mcaRequestId mcaPending",
    ],
  };
  const editFormSchema = {
    display: {
      mode: ENUM_FORM_DISPLAY.LINK,
    },
    title: "Debit Note",
    titleField: "code",
    apiEntity,
    initialValues,
    layout: {
      containers: [
        {
          key: "main-g",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
          props: {
            gutter: "xl",
            columns: 24,
          },
          cols: [
            {
              key: "main-g1",
              props: {
                span: 7,
              },
            },
            {
              key: "main-g2",
              props: {
                span: 17,
              },
            },
          ],
        },

        {
          key: "main-tab",
          parent: "main-g2",
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Overview",
          },
          tab: [
            {
              key: "tab-overview",
              label: "Overview",
              //icon: IconSettings,
            },
            {
              key: "tab-payment",
              label: "Payments",
              //icon: IconSettings,
            },
            {
              key: "tab-endorse",
              label: "Endorsements",
              //icon: IconSettings,
            },
            {
              key: "tab-insured",
              label: "Insured",
              //icon: IconSettings,
            },
            {
              key: "tab-commission",
              label: "Commission",
              showTab: (values) => showCommissionSetting,
              //icon: IconSettings,
            },
            {
              key: "tab-related-orders",
              label: "Related Orders",
            },
            {
              key: "tab-files",
              label: "Files",
              //icon: IconSettings,
            },
            {
              key: "tab-logs",
              label: "Logs",
              // icon: IconSettings
            },
            {
              key: "tab-accounting",
              label: "Accounting",
            },
          ],
        },
        {
          key: "section-applicant",
          parent: "main-g1",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Applicant Details",
            // titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-payment",
          parent: "tab-payment",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Payment Info",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-client-payment",
          parent: "tab-payment",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Payment Records",
            // titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-consultant",
          parent: "main-g1",
          type: ENUM_FORM_LAYOUT_CONTAINER.BOX,
          props: {
            mt: 0,
            mb: 0,
          },
        },

        {
          key: "section-summary",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Summary",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-timeline",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Timeline",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        //outstanding documents
        {
          key: "section-outstandingDocument",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Outstanding Documents",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "overview-mortgage-related",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default",
            defaultValue: "Related Documents",
          },
          tab: [
            {
              key: "tab-related-docs",
              label: "Related Documents",
            },
            {
              key: "tab-mortgagee-hp",
              label: "Mortgagee / Hire-Purchase",
              showTab: (values) => isMortgageeHirePurchaseProduct(values),
            },
          ],
        },
        {
          key: "section-mortgagee",
          parent: "tab-mortgagee-hp",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-relatedDocument",
          parent: "tab-related-docs",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        // {
        //   key: "section-endorsement-summary",
        //   parent: "tab-endorse",
        //   type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        //   visibleOnly: (values) => values?.type === "ENDOSE",
        //   props: {
        //     title: "Endorsement Info",
        //     withBorder: false,
        //     mt: 0,
        //     mb: "md",
        //   },
        // },
        {
          key: "section-remark",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Remark",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-address",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Order Address",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-insured",
          parent: "tab-insured",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Insured Details",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-commission",
          parent: "tab-commission",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Commission Settings",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-payrollBids",
          parent: "tab-commission",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Payroll Commission",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-insurerSettlement",
          parent: "tab-commission",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Insurer Settlement",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-tax",
          parent: "tab-commission",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Tax",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-related-debit-notes",
          parent: "tab-related-orders",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Related Debit Notes",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-files",
          parent: "tab-files",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          visibleOnly: () => role !== "CONSULTANT",
          props: {
            title: "Internal Files",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-consultant-files",
          parent: "tab-files",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,

          props: {
            title: "Consultant Files (Shared with Consultant)",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "main-tab",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Descriptions",
          },
          tab: [
            {
              key: "tab-descriptions",
              label: "Descriptions",
              //icon: IconSettings,
            },
            {
              key: "tab-particulars",
              label: "Particulars",
              //icon: IconSettings,
            },
            {
              key: "tab-terms",
              label: "Terms",
              //icon: IconSettings,
            },
          ],
        },
        {
          key: "tab-payment",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Charge Items",
          },
          tab: [
            {
              key: "tab-chargeItem",
              label: "Charge Items",
              //icon: IconSettings,
            },
            {
              key: "tab-costItem",
              label: "Cost Items",
              //icon: IconSettings,
              showTab: () => showCostItems,
            },
          ],
        },
        {
          key: "section-description",
          parent: "tab-descriptions",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Description",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-particulars",
          parent: "tab-particulars",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },

        {
          key: "section-term",
          parent: "tab-terms",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-charges",
          parent: "tab-chargeItem",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Charge Items",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-cost",
          parent: "tab-costItem",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Cost Items",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-providerReference",
          parent: "tab-overview",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          visibleOnly: () => role !== "CONSULTANT",
          props: {
            title:
              "Provider Reference (Screenshot from provider email if have)",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        // {
        // 	key: "section-payments",
        // 	parent: "tab-overview",
        // 	type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        // 	props: {
        // 		title: "Payments",
        // 		withBorder: false,
        // 		mt: 0,
        // 		mb: "md",
        // 	},
        // },
        {
          key: "section-endorse",
          parent: "tab-endorse",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Endorsements Records",
            withBorder: false,
            mt: 0,
            mb: "md",
          },
        },
        {
          key: "section-log",
          parent: "tab-logs",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            // title: "Logs",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-accounting",
          parent: "tab-accounting",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Accounting",
            withBorder: false,
            mt: 20,
            mb: 20,
          },
        },
        {
          key: "section-action-list",
          parent: "main-g1",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Action List",
            // titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 0,
            mb: 20,
          },
        },
      ],
      fields: [
        {
          name: "client",
          component: OrderApplicantDetail,
          parent: "section-applicant",
          props: {},
        },
        {
          name: "consultants",
          component: OrderConsultantList,
          parent: "section-consultant",
          props: {},
        },
        {
          name: "actionList",
          component: DebitNoteActionList,
          parent: "section-action-list",
          props: {
            role: role,
          },
        },
        {
          name: "summary",
          component: DebitNoteSummary,
          parent: "section-summary",
          props: {},
        },
        {
          name: "summary",
          component: DebitNoteTimeline,
          parent: "section-timeline",
          props: {},
        },
        {
          name: "summary",
          component: DebitNotePaymentSummary,
          parent: "section-payment",
          props: {},
        },
        // {
        //   name: "endorsementSummary",
        //   component: DebitNoteEndorsementSummary,
        //   parent: "section-endorsement-summary",
        //   props: {},
        // },
        {
          name: "outstandingDocs",
          component: OrderPendingCase,
          parent: "section-outstandingDocument",
          props: {},
        },
        {
          name: "mortgageeHirePurchaseName",
          component: TextInput,
          parent: "section-mortgagee",
          props: {
            label: "Mortgagee / Hire-Purchase Name",
            disabled: accessRight != 15,
          },
        },
        {
          name: "mortgageePostalAddress",
          component: Textarea,
          parent: "section-mortgagee",
          props: {
            label: "Mortgagee Postal Address",
            minRows: 3,
            disabled: accessRight != 15,
          },
        },
        {
          name: "mortgagePostDate",
          component: DatePicker,
          type: "datePicker",
          parent: "section-mortgagee",
          props: {
            label: "Post Date",
            zIndex: 1000,
            placeholder: "Pick Date",
            allowFreeInput: true,
            disabled: accessRight != 15,
          },
        },
        {
          name: "relatedDocuments",
          component: DebitNoteRelatedDocumentSection,
          parent: "section-relatedDocument",
          props: {
            readonly: accessRight != 15,
          },
        },

        {
          name: "insured",
          component: OrderInsuredList,
          parent: "section-insured",
          props: {
            readonly: accessRight != 15,
          },
        },

        {
          name: "addressStr",
          // component: OrderAddressSelect,
          component: Textarea,
          parent: "section-address",
          props: {
            disabled: accessRight != 15,
          },
        },
        {
          name: "address",
          component: OrderAddressSelect,
          parent: "section-address",
          props: {
            showAddressResult: false,
            onChangeAddress: (form, address, addressStr) => {
              form.setFieldValue("addressStr", addressStr);
            },
          },
        },

        {
          name: "descriptions",
          component: QuotationDescription,
          parent: "section-description",
          props: {
            required: true,
            readonly: accessRight != 15,
            enablePageBreak: true,
            enableCopyToDn: false,
          },
        },
        {
          name: "particulars",
          component: DNParticularList,
          parent: "section-particulars",
          props: {
            readonly: accessRight != 15,
          },
        },

        {
          name: "terms",
          component: QuotationTerms,
          parent: "section-term",
          props: {
            required: true,
            templateCategory: "DebitNote Terms",
            readonly: accessRight != 15,
          },
        },

        // {
        //   name: "commissionSetting",
        //   component: CommissionSetting,
        //   parent: "section-commission",
        //   props: {},
        // },
        {
          name: "orderCommissionSetting",
          component: DebitNoteCommissionSetting,
          parent: "section-commission",
          props: {
            readonly: accessRight != 15,
          },
        },
        {
          name: "payrollBidsSection",
          component: DebitNotePayrollBidsSection,
          parent: "section-payrollBids",
          props: {},
        },
        {
          name: "insurerSettlementSection",
          component: DebitNoteInsurerSettlementSection,
          parent: "section-insurerSettlement",
          props: {},
        },
        {
          name: "taxable",
          component: Switch,
          parent: "section-tax",
          fieldSpacing: "xs",
          props: {
            type: "checkbox",
            label: "Taxable",
            size: "xs",
            disabled: accessRight != 15,
          },
        },
        {
          name: "relatedDebitNotesSection",
          component: DebitNoteRelatedDebitNotesSection,
          parent: "section-related-debit-notes",
          props: {},
        },

        {
          name: "chargeItems",
          component: DebitNoteChargeItems,
          parent: "section-charges",
          props: {
            required: true,
            readonly: accessRight != 15,
          },
        },
        {
          name: "costItems",
          component: DebitNoteCostItems,
          parent: "section-cost",
          props: {
            required: true,
            allowGetRate: true,
            readonly: accessRight != 15,
          },
        },
        {
          name: "remark",
          component: Textarea,
          parent: "section-remark",
          props: {
            disabled: accessRight != 15,
          },
        },
        {
          name: "clientPayments",
          component: ClientPaymentList,
          parent: "section-client-payment",
          props: {
            readonly: accessRight != 15,
          },
        },
        {
          name: "summary",
          component: QuotationChargeSummary,
          parent: "section-charges",
          props: {
            required: true,
            disabled: accessRight != 15,
          },
        },
        {
          name: "files",
          component: FileList,
          parent: "section-files",
          props: {
            disabled: accessRight != 15,
            backupEntityType: "debitNote",
          },
        },
        {
          name: "consultantFiles",
          component: FileList,
          parent: "section-consultant-files",
          props: {
            disabled: accessRight != 15,
            backupEntityType: "debitNote",
          },
        },

        {
          name: "fileList",
          component: DNOrderFileList,
          parent: "section-order-files",
          props: {
            // title: "Please upload related files.",
            disabled: accessRight != 15,
          },
        },
        {
          name: "endorsements",
          component: DebitNoteEndorsementList,
          parent: "section-endorse",
          props: {
            readonly: accessRight != 15,
          },
        },

        {
          name: "log",
          component: ActivityLog,
          parent: "section-log",
          props: {
            readonly: accessRight != 15,
          },
        },
        {
          name: "accounting",
          component: AccountingSourceTab,
          parent: "section-accounting",
          props: {
            sourceType: "debitNote",
          },
        },
        {
          name: "providerCostReference",
          component: RichTextEditor,
          parent: "section-providerReference",

          props: {},
        },
      ],
    },
  };

  const formSchema = {
    add: addFormSchema,
    edit: editFormSchema,
  };

  const reviseSchemaForConsultant = async (activeRole = role) => {
    //Consultant
    //Set Pre Query
    try {
      const teamIds = await getTeamUserIds(auth, api);
      if (!isConsultantPortalRole(activeRole)) return;

      setTeamUserIds(teamIds);

      if (CONSULTANT_TEAM_SEARCH_ENABLED) {
        setPreQuery({
          consultants: { $in: teamIds },
        });
      } else {
        setPreQuery({ consultants: auth().id });
      }
    } catch (e) {
      if (!isConsultantPortalRole(activeRole)) return;
      // Fallback so page and stats always render
      setTeamUserIds([auth().id]);
      setPreQuery({ consultants: auth().id });
    }

    //Set Initial Values
    initialValues.consultants = [auth().id];
    initialValues.signedBy = auth().id;

    //Set Pre Query for Client field in add form
    const clientField = addFormSchema.layout.fields.find(
      (f) => f.name === "client",
    );
    clientField.props.preQuery = { consultants: auth().id };

    //Set Action List
    // const tabLayout = editFormSchema.layout.containers.find(
    //   (c) => c.key === "main-tab"
    // );
    // tabLayout.tab = tabLayout.tab.filter((t) => t.key != "tab-commission");

    // console.log("Tab Layout", tabLayout);
  };

  useEffect(() => {
    if (role === "CONSULTANT") {
      reviseSchemaForConsultant(role);
    } else {
      setTeamUserIds(null);
      setPreQuery({});
    }
  }, [role]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* accessRight:{accessRight} */}
      {/* <ReactJson src={auth()?.userRole} style={{ background: "white" }} /> */}
      {/* {role}
      {JSON.stringify(preQuery)} */}
      {/* {currentLink} */}
      {preQuery && (
        <PageList
          title={"Debit Note"}
          titleField={"code"}
          setDocumentTitle={true}
          apiEntity={apiEntity}
          tableSchema={tableSchema}
          formSchema={formSchema}
          searchByTextField={false}
          readOnly={accessRight != 15}
          showImport={true}
          showTemplateDownload={true}
          templateDownloadUrl={debitNoteImportTemplateUrl}
          templateDownloadText="Download Template"
          reloadAfterSave={true}
          initSort={{ by: "createdAt", order: "desc" }}
          stats={{
            component: DebitNotePageStats,
            props: {
              mb: 35,
              role,
              preQuery,
            },
          }}
        />
      )}
    </>
  );
};

export default DebitNote;
